import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { IEventCalendarView, TView } from "../../type/events.types";
import moment from "moment";
import EventButton from "./utils/event-button.view";
import Toolbar from "./utils/toolbar.view";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '../../../../styles/component/events-calendar.scss';


const localizer = momentLocalizer(moment)

const EventCalendarView: React.FC<IEventCalendarView> = (props) => {

    const [date, setDate] = useState(
        props.activeRange.start.toDate()
    );

    return (
        <>
            <Calendar
                className={'hrms-events__calendar'}
                localizer={localizer}
                events={props.data}
                startAccessor="start"
                endAccessor="end"
                defaultView="month"
                view={props.view}
                onView={(view) => props.updateView(view as TView)}
                date={date}
                onNavigate={(newDate) => setDate(newDate)}
                onDrillDown={(date) => {
                    setDate(date);
                    props.updateView('day')
                }}
                onRangeChange={props.handleRangeChange}

                components={{
                    event: (calendarProps) => (
                        <EventButton
                            {...calendarProps}
                            isAdmin={props.isAdmin}
                            openEditEventModal={props.openEditEventModal}
                            handleDeleteEvent={props.handleDeleteEvent}
                            handleCancelEvent={props.handleCancelEvent}
                        />),
                    toolbar: (toolbarProps) => (
                        <Toolbar
                            {...toolbarProps}
                            view={props.view}
                            updateView={props.updateView}
                            activeRange={props.activeRange}
                        />),

                    header: props.view === 'day'
                        ? ({date}) => (
                            <div className="custom-day-header">
                                {moment(date).format("DD MMMM YYYY")}
                            </div>
                        )
                        : undefined


                }}
            />
        </>

    )
}
export default EventCalendarView;
